export default __webpack_public_path__ + "static/Salt-8c267521e5504155bb2ab0c87a965f75.png";